import type { Tournament } from '@/lib/db/types';

interface Props {
  event: Tournament;
  courseName?: string;
  joined?: boolean;
  onOpen: () => void;
}

export function TournamentCard({ event, courseName, joined, onOpen }: Props) {
  const statusLabel = event.status === 'open' ? 'Open' : event.status === 'in-progress' ? 'Live' : event.status === 'completed' ? 'Finished' : event.status;
  const date = event.starts_at ? new Date(event.starts_at).toLocaleDateString([], { month: 'short', day: 'numeric' }) : 'TBD';
  const isPrivate = (event.config as { visibility?: string } | undefined)?.visibility === 'private';

  return (
    <button type="button" onClick={onOpen} className="w-full rounded-[14px] border border-line bg-paper p-4 text-left shadow-bt">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="font-serif text-lg font-bold tracking-[-0.01em] text-ink">{event.name}</div>
          <div className="mt-1 text-sm text-ink-soft">{date} · {courseName || 'Course TBD'}</div>
          {event.description && <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-ink-soft">{event.description}</p>}
        </div>
        <div className="shrink-0 space-y-1 text-right">
          <span
            className={`inline-block rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase ${
              event.status === 'in-progress'
                ? 'bg-red-100 text-red-700'
                : event.status === 'open'
                  ? 'bg-gold/20 text-gold-deep'
                  : 'bg-cream text-ink-soft'
            }`}
          >
            {statusLabel}
          </span>
          {joined && <div className="text-[10px] font-bold text-gold-deep">JOINED</div>}
          {isPrivate && <div className="text-[10px] font-bold text-navy">PRIVATE</div>}
        </div>
      </div>
      {event.entry_fee_cents > 0 && (
        <div className="mt-2 text-xs font-semibold text-mute">Entry ${(event.entry_fee_cents / 100).toFixed(0)}</div>
      )}
    </button>
  );
}
